import * as Storage from './storage';
import { post, get, put } from './request';
import type { MessageType } from '../components/FollowUp';
import type { ClaimPendencyValues } from '../components/ClaimFollowUpPendencyFields';

export async function getMessages(id: string, page: number): Promise<any> {
  const response = await get(`/claims/messages/${id}?page=${page}`);
  return response;
}

export async function sendMessage(
  claimId: string,
  userId: string,
  text: string,
  senderName: string,
  pendency?: ClaimPendencyValues
): Promise<MessageType> {
  const payload = {
    claim_estate_id: claimId,
    sender_id: userId,
    text,
    sender_name: senderName,
    pending_responsible: pendency?.responsible,
    pending_type: pendency?.type
  };

  const response = await post('/claims/save-message', payload);
  return response;
}

export async function sendWebhookFiles(claimId: string, files: any[]): Promise<any> {
  const payload = {
    claim_id: claimId,
    files: files
  };
  const response = await post('/claims/send-webhook-files', payload);
  return response;
}

export async function updateViewed(
  id: string,
  viewer_id: string,
  viewed = true
): Promise<any> {
  const payload = {
    viewer_id,
    viewed
  };
  const response = await put(`/claims/update-message/${id}`, payload);
  return response;
}
